import { CSSProperties } from "react";
import { useTheme } from "../../../context/themeContext";

const BiButton: React.FC<{
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  onClick?: Function;
  style?: CSSProperties;
  children?: any;
}> = (props) => {
  const theme = useTheme().theme;

  const cssClass = () => {
    const classes = [
      "md:px-4 px-2.5",
      "md:py-2 py-1.5",
      "text-center",
      "rounded-md",
      "font-semibold",
      "md:text-base text-sm",
    ];
    const { disabled, className } = props;

    if (className && className.trim().length > 0) {
      classes.push(...className.split(" "));
    }

    if (disabled) {
      const index = classes.findIndex((item) => item === "bg-primary");
      classes.splice(index, 1);
      classes.push("bg-disabled", "cursor-not-allowed");
    }

    return classes.join(" ");
  };

  const onClick = () => {
    if (!props.disabled && props.onClick) {
      props.onClick();
    }
  };

  const cssStyles = () => {
    const { className, disabled } = props;
    const classes = [];
    if (className && className.trim().length > 0) {
      classes.push(...className.split(" "));
    }
    const index = classes.findIndex((item) => item === "bg-primary");
    const secondaryIndex = classes.findIndex((item) => item === "secondary");
    const tertiaryIndex = classes.findIndex((item) => item === "tertiary");
    if (disabled && index !== -1) {
      return theme.bgPrimaryDisabledStyleColor;
    } else if (index !== -1) {
      return theme.bgPrimaryStyleColor;
    } else if (secondaryIndex !== -1) {
      return theme.secondaryButton;
    } else if (tertiaryIndex !== -1) {
      return theme.tertiaryButton;
    } else {
      return {};
    }
  };

  return (
    <button
      className={cssClass()}
      type={props.type || "button"}
      disabled={props.disabled}
      onClick={onClick}
      style={{ ...cssStyles(), ...props.style }}
    >
      {props.children}
    </button>
  );
};

export default BiButton;
